<template>
  <div class="animated fadeIn">
    <b-container fluid class="order-list">

      <div v-show="errorText !== ''" class="alert alert-danger" role="alert">
        {{ errorText }}
      </div>

      <b-row class="filter-row">
        <b-col lg="4">
          <b-form-group :label="$t('Buscar')"
            :invalid-feedback="!isValidText(filter, false) ? $t('No es un valor válido') : ''"
            :state="isValidText(filter, false)" class="mb-0" :description="$t('Ingrese el texto a buscar')">
            <b-input-group>
              <b-form-input v-model="filter" :placeholder="$t('Texto a buscar')" />
              <b-input-group-button>
                <b-btn @click="filterTable">{{ $t('Buscar') }}</b-btn>
              </b-input-group-button>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg-="8" class="mt-4">
          <button type="button" class="btn btn-primary float-right" @click.stop="showFilters = !showFilters">
            <i class="fa" :class="{ 'fa-times': showFilters, 'fa-filter': !showFilters }" />{{ $t('Filtros') }}
          </button>
        </b-col>
      </b-row>

      <transition name="fade">
        <div class="filters mt-3 p-3" v-show="showFilters">
          <b-row>
            <b-col lg="4">
              <b-form-group :label="$t('Desde')" class="mb-0" :description="$t('Fecha de inicio para filtrar datos')"
                :state="invalidDateFrom === '' ? true : false" :invalid-feedback="invalidDateFrom">
                <b-input-group>
                  <date-picker v-on:contextmenu.native.stop.prevent v-on:keydown.native.stop.prevent v-model="fromDate"
                    :config="config"></date-picker>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group :label="$t('Hasta')" class="mb-0" :description="$t('Fecha final para filtrar datos')"
                :state="invalidDateTo === '' ? true : false" :invalid-feedback="invalidDateTo">
                <b-input-group>
                  <date-picker v-on:contextmenu.native.stop.prevent v-on:keydown.native.stop.prevent v-model="toDate"
                    :config="config"></date-picker>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group :label="$t('Estado')" class="mb-3" :description="$t('Seleccione el estado de la orden')">
                <b-form-select v-model="statusName">
                  <option slot="first" :value="null">{{ $t('Todos') }}</option>
                  <option v-for="(text, value) in filterStatusMapping" :key="value" :value="value">{{ $t(text) }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" class="col-multiselect">
              <b-form-group :label="$t('Filtrar por TAGS')"
                :description="$t('Selecciones los tags de ordenes que desea filtrar en la busqueda')">
                <multiselect v-model="filterTags" label="text" :placeholder="$t('Todos')"
                  :selectedLabel="$t('Seleccionado')" :selectLabel="$t('Enter para agregar el tag')"
                  :deselectLabel="$t('Enter para retirar el tag')" track-by="key" :options="tagsToFilter" :multiple="true"
                  :taggable="true">
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col lg="4" v-if="isAdmin">
              <b-form-group :label="$t('Seller')" class="mb-3">
                <autocomplete
                  id="inputSellers"
                  name="inputSellers"
                  :maxElements="1"
                  :provider="getSearchSeller"
                  :selectLabel="$t('Enter para agregar Seller')"
                  :searchLength="2"
                  :findOnMounted="false"
                  v-model="accountAux">
                  <!-- :disabled="loading" -->
                </autocomplete>
              </b-form-group>
            </b-col>
            <b-col lg="4" v-if="isAdminLogistic && organizations.length > 1">
              <b-form-group :label="$t('Seller')" class="mb-3">
                <autocomplete
                  id="inputSellers"
                  name="inputSellers"
                  :maxElements="1"
                  :provider="getSearchSeller"
                  :selectLabel="$t('Enter para agregar Seller')"
                  :findOnMounted="organizations.length > 4 ? false : true"
                  :searchLength="organizations.length > 4 ? 2 : 0"
                  v-model="accountAux">
                </autocomplete>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group :label="$t('Sub-estados')" class="mb-3">
                <b-form-select v-model="substatusFilter">
                  <option slot="first" :value="null">{{ $t('Todos') }}</option>
                  <option v-for="(text, value) in substatus" :key="value" :value="text.id">
                    {{ capitalizeText($t(text.name)) }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4">
              <b-form-group :label="$t('Forma de entrega')" class="mb-3" :description="$t('Selecciona la forma de entrega')">
                <b-form-select v-model="deliveryMethod">
                  <option slot="first" :value="null">{{$t('Todos')}}</option>
                  <option v-for="deliveryMethodOption in deliveryMethodsOptions" :key="deliveryMethodOption.value"
                        :value="deliveryMethodOption.value">{{$t(deliveryMethodOption.text)}}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-input-group-button class="float-right mt-3">
                <b-button :disabled="loading" variant="primary" class="mr-2"
                  @click.stop="clearFilters">{{ $t('Mostrar Todos') }}</b-button>
                <b-button :disabled="loading || disableFilter" :block="true" variant="primary"
                  @click.stop="filterTable">{{ $t('Filtrar') }}</b-button>
              </b-input-group-button>
            </b-col>
          </b-row>
        </div>
      </transition>

      <b-row class="mt-3">
        <b-col class="col-md-auto">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mb-3" />
        </b-col>
        <b-col class="col-md-auto">
          <b-form-group id="perPage" horizontal :label="$t('Mostrar por página')">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col md="12">
          <b>{{ $tc('{count} ordenes encontradas', totalRows, { count: totalRows }) }}</b>
        </b-col>
      </b-row>
      <b-card header-bg-variant="primary" border-variant="primary" :header="$t('Listado de ordenes')">
        <moon-loader :loading="loading" color="#000" size="30px"></moon-loader>
        <b-table
          v-show="!loading"
          id="mainTable"
          ref="mainTable"
          show-empty
          striped
          hover
          stacked="xl"
          :items="itemProvider"
          foot-clone
          :fields="(isAdmin || (isAdminLogistic && organizations.length > 1)) ? fields : fieldsNotAdmin"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @row-clicked="rowClick"
          @filtered="onFiltered"
          :empty-text="$t('No hay ordenes para mostrar')"
          :empty-filtered-text="$t('No hay ordenes para mostrar')">
          <template slot="clientProfileData" slot-scope="data">
            {{ data.value ? data.value.firstName : '' }} {{ data.value ? data.value.lastName : '' }}
          </template>
          <template slot="status" slot-scope="status">
            <span :class="getStatusColorClass(status.value)"><b>{{ $t(statusMapping[status.value]) }}</b></span>
          </template>
          <template slot="subStatus" slot-scope="subStatus">
            <p class="substatus-name" v-if="subStatus.item.subStatus">{{ subStatus.item.subStatus.name }}</p>
            <p v-else>-</p>
          </template>
          <template slot="creationDate" slot-scope="creationDate">

            {{ formatDateTime(creationDate.value) }}
          </template>
          <template slot="value" slot-scope="value">
            {{ currency }} {{ value.value }}
          </template>
          <template slot="deliveryMethod" slot-scope="row">
            {{ getDeliveryMethodName(row.item.deliveryMethod) }}
          </template>
          <template slot="tags" slot-scope="row">
            <b-badge
              v-if="tagElemKey in tagsMapping"
              v-for="(tagElemKey, index) in row.item.tags"
              v-b-tooltip.hover
              class="mr-2"
              :class="tagsMapping[tagElemKey].bg"
              :title="$t(tagsMapping[tagElemKey].description)"
              :key="index"
            >
              {{tagElemKey}}
            </b-badge>
          </template>
        </b-table>
      </b-card>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
// Date Picker
import Vue from 'vue'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import Multiselect from 'vue-multiselect'
import appConfig from '@/config/applicationConfig.js'

import { OrdersServiceMixim } from '@/mixims/OrdersServiceMixim.js'
import { SubStatusMixim } from '@/mixims/SubStatusMixim.js'
import { OrganizationService } from '@/mixims/AdminServiceMixin'
import { ValidationsMixim } from '@/mixims/ValidationsMixim.js'
import autocomplete from '@/components/common/vue-autocomplete'
import { formatDateTime } from '@/utils/dates'

Vue.use(datePicker)

export default {
  name: 'order-list',
  mixins: [OrdersServiceMixim, ValidationsMixim, SubStatusMixim, OrganizationService],
  components: { MoonLoader, Multiselect, autocomplete },
  data() {
    return {
      fields: [
        { key: 'id', label: this.$t('Número'), 'class': 'text-left', sortable: true },
        { key: 'accountName', label: this.$t('Seller'), 'class': 'text-left', sortable: true },
        { key: 'clientProfileData', label: this.$t('Cliente'), 'class': 'text-left', sortable: true },
        { key: 'creationDate', label: this.$t('Fecha'), 'class': 'text-left', sortable: true },
        { key: 'value', label: this.$t('Total'), 'class': 'text-left', sortable: true },
        { key: 'status', label: this.$t('Estado'), 'class': 'text-left', sortable: true },
        { key: 'subStatus', label: this.$t('Sub estado'), 'class': 'text-left', sortable: true },
        { key: 'tags', label: this.$t('Etiquetas'), 'class': 'text-left' },
        { key: 'deliveryMethod', label: this.$t('Forma de entrega'), 'class': 'text-left', sortable: false }
      ],
      fieldsNotAdmin: [
        { key: 'id', label: this.$t('Número'), 'class': 'text-left', sortable: true },
        { key: 'clientProfileData', label: this.$t('Cliente'), 'class': 'text-left', sortable: true },
        { key: 'creationDate', label: this.$t('Fecha'), 'class': 'text-left', sortable: true },
        { key: 'value', label: this.$t('Total'), 'class': 'text-left', sortable: true },
        { key: 'status', label: this.$t('Estado'), 'class': 'text-left', sortable: true },
        { key: 'subStatus', label: this.$t('Sub estado'), 'class': 'text-left', sortable: true },
        { key: 'tags', label: this.$t('Etiquetas'), 'class': 'text-left', sortable: false },
        { key: 'deliveryMethod', label: this.$t('Forma de entrega'), 'class': 'text-left', sortable: false }
      ],
      isAdmin: this.$store.getters.isAdmin,
      isAdminLogistic: this.$store.getters.isAdminLogistic,
      organizations: this.$store.state.user_data.organizations,
      currentPage: 1,
      selectedSellers: null,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      account: null,
      accountAux: null,
      deliveryMethodsOptions: appConfig.DELIVERY_METHODS,
      deliveryMethod: null,
      sortBy: null,
      sortDesc: false,
      filter: null,
      filterTags: [],
      errorText: '',
      statusName: null,
      fromDate: new Date(),
      toDate: new Date(),
      showFilters: false,
      loading: false,
      locale: appConfig.LOCALE,
      currency: appConfig.CURRENCY !== "" ? appConfig.CURRENCY : '$',
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        icons: {
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right'
        }
      },
      statusMapping: appConfig.STATUS_MAPPING,
      filterStatusMapping: appConfig.FILTER_STATUS_MAPPING,
      statusMappingColors: appConfig.STATUS_MAPPING_COLORS,
      tagsMapping: appConfig.TAGS_MAPPING,
      tagsToFilter: [],
      substatus: '',
      substatusFilter: null,
    }
  },
  watch: {
    accountAux: function (val, oldVal) {
      this.account = (val && val[0] && val[0].id) ? val[0].id : null
    }
  },
  computed: {
    disableFilter() {
      return this.invalidDateTo !== '' || this.invalidDateFrom !== '' || !this.isValidText(this.filter)
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    invalidDateTo() {
      if (this.toDate) {
        let tDate = new Date(this.toDate)
        if (tDate > new Date()) {
          return this.$t('La fecha seleccionada es mayor al día de hoy')
        }
        if (this.fromDate) {
          let fDate = new Date(this.fromDate)
          return fDate > tDate ? this.$t('La fecha final es menor a la fecha inicial') : ''
        }
      }
      return ''
    },
    invalidDateFrom() {
      if (this.fromDate) {
        let fDate = new Date(this.fromDate)
        if (fDate > new Date()) {
          return this.$t('La fecha seleccionada es mayor al día de hoy')
        }
      }
      return ''
    }
  },
  methods: {
    formatDateTime,
    updateAccount (newValues) {
      this.account = newValues ? newValues.id : null
    },
    clearSeller () {
      this.selectedSellers = null
    },
    capitalizeText(item) {
      return item.slice(0, 1).toUpperCase() + item.slice(1).toLowerCase()
    },
    getStatusColorClass: function (status) {
      return 'text-' + this.statusMappingColors[status] + ' h6'
    },
    controversyTagClass: function (row) {
      let days = 0
      if (row.controversies && row.controversies.length > 0) {
        let auxDays = 0
        row.controversies.forEach((cont) => {
          let timeDiff = (new Date()) - (new Date(cont.updateDate))
          auxDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
          days = auxDays >= days ? auxDays : days
        })
      }
      if (days < 1) return 'green'
      if (days < 2) return 'yellow'
      return 'red'
    },
    showControversyTag(orderDesc) {
      if (orderDesc.controversies !== null && orderDesc.controversies.length > 0) {
        return (orderDesc.controversies.find(
          (item) => {
            return item.state !== 'INVALID' && item.state !== 'DONE'
          }) !== undefined)
      }
      return false
    },
    rowClick(item) {
      this.saveFilters()
      this.$router.push(`/orders/orderDetail/${item.id}`)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    clearFilters() {
      this.filter = null
      this.fromDate = ''
      this.toDate = ''
      this.statusName = null
      this.filterTags = []
      this.accountAux = null
      this.account = null
      this.deliveryMethod = null
      this.substatusFilter = null
      this.currentPage = 1
      setTimeout(() => {
        this.$refs.mainTable.refresh()
      }, 100)
    },
    filterTable() {
      this.currentPage = 1
      setTimeout(() => {
        this.$refs.mainTable.refresh()
      }, 100);
    },
    itemProvider(tableComponentInfo) {
      if(this.loading)
        return
      this.loading = true
      this.errorText = ''
      return this.getAllOrders(tableComponentInfo).then(function (response) {
        this.loading = false
        let items = response.body
        this.totalRows = parseInt(response.headers.get('X-Total-Count'))
        return items
      },
        (error) => {
          this.loading = false
          this.errorText = error.body.message || this.$t('Error obteniendo el listado de pedidos')
          return []
        })
    },
    getSubStatus() {
      return this.getAllStatus(null).then(function (response) {
        this.substatus = response.body
      },
        (error) => {
          this.errorText = error.body.message || this.$t('Error obteniendo el listado de estados')
          return []
        })
    },
    saveFilters() {
      this.$store.dispatch('setOrderFilter', {
        showFilters: this.showFilters,
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        deliveryMethod: this.deliveryMethod,
        sortDesc: this.sortDesc,
        totalRows: this.totalRows,
        filter: this.filter,
        fromDate: this.fromDate,
        toDate: this.toDate,
        statusName: this.statusName,
        filterTags: this.filterTags,
        account: this.accountAux,
        substatusFilter: this.substatusFilter
      })
    },
    restoreFilters() {
      let prevFilter = this.$store.getters.getOrderFilter
      if (prevFilter) {
        if(prevFilter.showFilters === true || prevFilter.showFilters === false) {
          this.showFilters = prevFilter.showFilters
        }
        if (prevFilter.deliveryMethod) {
          this.deliveryMethod = prevFilter.deliveryMethod
        }
        if (prevFilter.currentPage) {
          this.currentPage = prevFilter.currentPage
        }
        if (prevFilter.perPage) {
          this.perPage = prevFilter.perPage
        }
        if (prevFilter.sortBy) {
          this.sortBy = prevFilter.sortBy
        }
        if(prevFilter.sortDesc === true || prevFilter.sortDesc === false) {
          this.sortDesc = prevFilter.sortDesc
        }
        if (prevFilter.totalRows) {
          this.totalRows = prevFilter.totalRows
        }
        if (prevFilter.filter) {
          this.filter = prevFilter.filter
        }
        if (prevFilter.fromDate) {
          this.fromDate = prevFilter.fromDate
        }
        if (prevFilter.toDate) {
          this.toDate = prevFilter.toDate
        }
        if (prevFilter.statusName) {
          this.statusName = prevFilter.statusName
        }
        if (prevFilter.filterTags) {
          this.filterTags = prevFilter.filterTags
        }
        if (prevFilter.account && prevFilter.account.length > 0) {
          this.account = prevFilter.account[0].id
          this.accountAux = prevFilter.account
        }
        if (prevFilter.substatusFilter) {
          this.substatusFilter = prevFilter.substatusFilter
        }
      }
    },
    getDeliveryMethodName (paymenthMethodCode) {
      let item = this.deliveryMethodsOptions.find(x => x.value === paymenthMethodCode)
      if (item && item.text) {
        return item.text
      } else {
        return '-'
      }
    }
  },
  beforeMount () {
    this.fromDate = ''
    this.toDate = ''
    this.restoreFilters()
  },
  mounted () {
    setInterval(() => {
      if (this.$refs.mainTable) {
        this.$refs.mainTable.refresh()
      }
    }, appConfig.ORDER_LIST_TTL)

    let filters = Object.keys(appConfig.TAGS_MAPPING).map((key) => {
      return {
        'text': this.$t(appConfig.TAGS_MAPPING[key].text),
        'key': appConfig.TAGS_MAPPING[key].key,
        'isCt': appConfig.TAGS_MAPPING[key].isCt,
        'onlyAdmin': appConfig.TAGS_MAPPING[key].onlyAdmin
      }
    }).filter(tag => !tag.isCt)
    this.tagsToFilter = this.isAdmin ? filters : filters.filter(tag => !tag.onlyAdmin)
    this.getSubStatus()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.order-list {
  .substatus-name::first-letter {
    text-transform: uppercase;
  }

  .orderTable {
    table-layout: fixed;
  }

  .filter-row {
    .btn-primary {
      width: 80px;
    }

    button {
      i {
        margin-right: 5px;
      }
    }
  }

  .filters {
    border: 1px solid #e3e8ec;
    background-color: #FFF
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }

  .tag {
    width: fit-content;
    padding: 2px 11px;
    display: inline-block;
    border-radius: 5px;
    line-height: 17px;
    margin-right: 4px;
    cursor: pointer;
    text-align: center;

    &.green {
      background: #4DBD74;
      color: #FFFFFF;
    }

    &.yellow {
      background: #e8f48b;
    }

    &.red {
      background: #f23c3c;
      color: #FFFFFF;
    }
  }

  tr:hover {
    cursor: pointer
  }

  .col-multiselect {
    z-index: 3;
    position: relative;
  }
}

::v-deep .multiselect__tags {
  min-height: 35px;
  padding: 5px 40px 0 8px;
  border-radius: 0;
}

::v-deep .multiselect__tag {
  margin-bottom: 0;
}

::v-deep .multiselect__select {
  height: 35px;
}

::v-deep .multiselect__placeholder {
  margin-bottom: 5px;
}

::v-deep .multiselect__input {
  margin-bottom: 5px;
  margin-top: 3px;
}

.custom__tag-custom {
  border-radius: 3px;
  width: fit-content;
  background: #DDD;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 4px 2px;
  white-space: nowrap;
  margin-right: 5px;
  pointer-events: none;
  span {
    font-size: 14px;
  }
}

.multiselect--disabled {
  background: #ededed;
  pointer-events: none;
  opacity: 1 !important;
}

::v-deep .multiselect--disabled {
  background: #ededed;
  pointer-events: none;
  opacity: 1 !important;
}

.multiselect__single {
  margin-bottom: 0px !important;
}
::v-deep .multiselect__single {
  margin-bottom: 0px !important;
}

.custom__remove-custom {
  margin-left: 2px;
  margin-right: 2px;
  font-size: 12px;
  cursor: pointer;
  pointer-events: all;
  border: none;
  outline: none;
  background: transparent;
}
</style>
